@if (dataSetFeatures().length === 0) {
  <p class="no-data">No features available</p>
} @else {
  <div class="card">
    <div class="table-header">
      <h2>Table features</h2>
      <div class="actions">
        <p-iconField iconPosition="left" class="ml-auto">
          <p-inputIcon>
            <i class="pi pi-search"></i>
          </p-inputIcon>
          <input
            pInputText
            type="text"
            (input)="ds.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Search..."
          />
        </p-iconField>
      </div>
    </div>

    <div class="table-container">
      <p-table
        #ds
        [value]="dataSetFeatures()"
        [tableStyle]="{ 'min-width': '5rem' }"
        [scrollable]="true"
        scrollHeight="500px"
        [globalFilterFields]="[
          'featureId',
          'name',
          'description',
          'ontology',
          'dataType',
          'entityType',
          'visibility',
          'acceptedValues',
          'minDate',
          'maxDate',
          'minValue',
          'maxValue',
          'profile.entropy',
          'profile.density',
          'profile.missingPercentage',
          'profile.dataTypeValidity',
          'profile.uniqueness',
          'profile.accuracyScore',
          'profile.minValue',
          'profile.maxValue',
          'profile.mean',
          'profile.median',
          'profile.standardDeviation',
          'profile.skewness',
          'profile.kurtosis',
          'profile.medianAbsoluteDeviation',
          'profile.interQuartileRange',
          'profile.minDate',
          'profile.maxDate',
          'profile.medianDate',
          'profile.interQuartileRangeDate',
          'profile.imbalance',
          'profile.constancy',
          'profile.mode',
          'profile.correlationMatrix',
        ]"
      >
        <ng-template pTemplate="header">
          <tr>
            @for (column of tableColumns; track column) {
              <th [ngStyle]="column?.styles">
                {{ column.name }}
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.featureId ?? '-' }}</td>
            <td>{{ row.name ?? '-' }}</td>
            <td>{{ row.description ?? '-' }}</td>
            <td>{{ row.ontology ?? '-' }}</td>
            <td>{{ row.dataType ?? '-' }}</td>
            <td>{{ row.entityType ?? '-' }}</td>
            <td>{{ row.visibility ?? '-' }}</td>
            <td>{{ row.acceptedValues ?? '-' }}</td>
            <td>{{ row.minValue ?? row.minDate ?? '-' }}</td>
            <td>{{ row.maxValue ?? row.maxDate ?? '-' }}</td>
            <td>{{ row.profile.minValue ?? row.profile.minDate ?? '-' }}</td>
            <td>{{ row.profile.maxValue ?? row.profile.maxDate ?? '-' }}</td>
            <td>{{ row.profile?.mean ?? '-' }}</td>
            <td>{{ row.profile?.median ?? '-' }}</td>
            <td>{{ row.profile?.standardDeviation ?? '-' }}</td>
            <td>{{ row.profile?.skewness ?? '-' }}</td>
            <td>{{ row.profile?.kurtosis ?? '-' }}</td>
            <td>{{ row.profile?.medianAbsoluteDeviation ?? '-' }}</td>
            <td>
              {{
                row.profile?.interQuartileRange ??
                  row.profile.interQuartileRangeDate ??
                  '-'
              }}
            </td>
            <td>{{ row.profile?.entropy ?? '-' }}</td>
            <td>{{ row.profile?.density ?? '-' }}</td>
            <td>{{ row.profile?.missingPercentage ?? '-' }}</td>
            <td>{{ row.profile?.dataTypeValidity ?? '-' }}</td>
            <td>{{ row.profile?.uniqueness ?? '-' }}</td>
            <td>{{ row.profile?.accuracyScore ?? '-' }}</td>
            <td>{{ row.profile?.imbalance ?? '-' }}</td>
            <td>{{ row.profile?.constancy ?? '-' }}</td>
            <td>
              {{ row.profile?.mode?.label ?? row.profile?.mode ?? '-' }}
            </td>
            <td>
              {{
                JSON.stringify(row.profile?.correlationMatrix) !== 'null'
                  ? JSON.stringify(row.profile?.correlationMatrix)
                  : '-'
              }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
